import React, { useEffect, useState } from "react";
import RingLoader from "react-spinners/RingLoader";
export default function LoadingAnimation() {
  return (
    <div className="loader-overlay">
      <RingLoader
        color={"#4169e1"}
        loading={true}
        //   cssOverride={override}
        size={100}
        aria-label="Loading Spinner"
      />
    </div>
  );
}
